<template>
  <div id="rf-footer">
    <p class="playfair-normal"> {{ strings.footerTitle }} </p>
    <div class="icons">
      <a href="https://www.facebook.com/reforminstitutet/" target="_blank"><img src="../assets/img/icon-fb.svg" alt="facebook.svg"></a>
      <a href="https://twitter.com/reformera" target="_blank"><img src="../assets/img/icon-tw.svg" alt="twitter.svg"></a>
    </div>
    <div class="email">
      <p> {{ strings.footerText }} </p>
      <a :href="'mailto:' + strings.email" target="_blank"> {{ strings.email }} </a>
    </div>
    <p class="copyright"> &#169; 2018 Reforminstitutet</p>
  </div>
</template>

<script>
export default {
  name: 'RfFooter',
  data () {
    return {
      msg: 'Empty component'
    }
  },
  props: [],
  methods: {
  },
  computed: {
    pages () {
      return this.$store.state.pages
    },
    strings () {
      let returner = {
        footerTitle: '...',
        footerText: '...',
        email: '...'
      }
      if (this.pages && typeof this.pages[0] !== 'undefined') {
        returner.footerText = this.pages[0].acf.footer_text
        returner.email = this.pages[0].acf.email
        returner.footerTitle = this.pages[0].acf.footer_title
      }
      return returner
    }
  },
  watch: {
    pages () {
      //  console.log(this.pages)
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
#rf-footer {
  height: 50vh;
  width: 100vw;
  background-color: $purple;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
  .playfair-normal {
    margin-bottom: 36px;
  }
  a {
    margin: 15px;
  }
  .email a {
    color: white;
    margin: 0 0 0 10px;
    font-size: 16px;
  }
  .email {
    margin-top: 36px;
    display: flex;
    flex-direction: row;
    font-size: 16px;
  }
  .copyright {
    margin-top: 36px;
    font-size: 16px;
  }
  .icons a > img {
    transition: all 0.2s ease;
  }
  .icons a:hover > img {
    transform: scale(0.92);
  }
}
@media #{$phones} {
 #rf-footer .email {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RfFooter.vue